import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const Cont = styled.div((props) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
}))

export const SContDetail = styled.div((props) => ({
  display: 'flex',
  marginTop: `${props.sub ? '0' : '1rem'}`,
  flexDirection: 'column',

  '&>div:first-child': {
    marginLeft: 0,
    flex: 1
  },

  '&>div': {
    marginLeft: '0px',
    flex: 1
  },

  '@media only screen and (min-width: 600px)': {
    flexDirection: 'unset',

    '&>div': {
      marginLeft: '1rem',
      flex: 1
    },
  },

  '@media only screen and (min-width: 769px)': {
    flexDirection: 'unset',

    '&>div': {
      marginLeft: '1rem',
      flex: 1
    },
  },

}))

export const SContVDetail = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',

  '&>div:first-child': {
    marginTop: 0,
  },
  '&>div': {
    marginTop: '1rem',
  }
}))